import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { from, throwError, BehaviorSubject } from 'rxjs';
import { share, map, tap, catchError } from 'rxjs/operators';

import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class ApiService {

  baseApiUrl: string = environment.baseApiUrl;
  apiAuth: string = environment.apiAuth;
  apiPass: string = environment.apiPass;

  userID = (JSON.parse(localStorage.getItem('userData'))).id;

  httpFormOptions = {
    headers: new HttpHeaders({
      Authorization: 'Basic ' + btoa(this.apiAuth + ':' + this.apiPass)
    })
  };

  constructor(private http: HttpClient, private router: Router) {}

  getRoutes() {
    return this.http.post<any>(
      `${environment.baseApiUrl}route/list`,
      {user_id: this.userID},
      this.httpFormOptions
    )
    .pipe(
      catchError(errorRes => {
        const errorMessage = errorRes.error.message;
        throw new Error(errorMessage);
      }),
      tap(resData => {
        resData.data = resData.data.filter(function( route ) {
            return route.etat !== 0;
        });
        resData.data.forEach(function(element){
          element.created_at = new Date(element.created_at).toLocaleDateString("fr-FR", {
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
          });
          element.updated_at = new Date(element.updated_at).toLocaleDateString("fr-FR", {
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
          });
          element.activePoints = element.points.filter((point) => point.etat === 2).length;
        });
        localStorage.setItem('userRoutes', JSON.stringify(resData.data));
      })
    );
  }

  addRoute(lang: string, title: string, options?: {route_id?: string, description?: string, youtube?:string, medias?: any, etat?: string}) {

    const form: FormData = new FormData();
    form.set('user_id', this.userID);
    form.set('lang', lang);
    form.set('title', title);
    if (options.route_id) {
      form.set('route_id', options.route_id);
    }
    if (options.description) {
      form.set('description', options.description);
    }
    if (options.youtube) {
      form.set('youtube', options.youtube);
    }
    if (options.medias) {
      let i;
      for (i = 0; i < options.medias.length; i++) {
        if (!options.medias[i].name) {
          form.set(options.medias[i].size, options.medias[i]);
        } else {
          form.set(options.medias[i].name, options.medias[i]);
        }
      }
    }
    if (options.etat) {
      form.set('etat', options.etat);
    }

    return this.http.post<any>(
      `${environment.baseApiUrl}route/add`,
      form,
      this.httpFormOptions
    )
    .pipe(
      catchError(errorRes => {
        const errorMessage = errorRes.error.message;
        throw new Error(errorMessage);
      }),
      tap(resData => {
      })
    );
  }

  getPoints(lang: string, options?: {route_id?: string}) {
    const form: FormData = new FormData();
    form.set('user_id', this.userID);
    form.set('lang', lang);

    if (options && options.route_id) {
      form.set('route_id', options.route_id);
    }

    return this.http.post<any>(
      `${environment.baseApiUrl}point/list`,
      form,
      this.httpFormOptions
    )
    .pipe(
      catchError(errorRes => {
        const errorMessage = errorRes.error.message;
        throw new Error(errorMessage);
      }),
      tap(resData => {
        resData.data = resData.data.filter(function( point ) {
            return point.etat == 2;
        });
        localStorage.setItem('currentRoutePoints', JSON.stringify(resData.data));
      })
    );
  }

  addPoint(route_id: string, lang: string, lat: string, lon: string, title: string, options?: {point_id?: string, googleplace_id?: string, description?:string, moreinfo?: string, youtube?: string, medias?: any, etat?: string, order?: string, statut_edit?: string}) {

    const form: FormData = new FormData();
    form.set('user_id', this.userID);
    form.set('route_id', route_id);
    form.set('lang', lang);
    form.set('lat', lat);
    form.set('lon', lon);
    form.set('title', title);

    if (options.point_id) {
      form.set('point_id', options.point_id);
    }
    if (options.googleplace_id) {
      form.set('googleplace_id', options.googleplace_id);
    }
    if (options.description) {
      form.set('description', options.description);
    }
    if (options.moreinfo) {
      form.set('moreinfo', options.moreinfo);
    }
    if (options.youtube) {
      form.set('youtube', options.youtube);
    }
    if (options.medias) {
      let i;
      for (i = 0; i < options.medias.length; i++) {
        if (!options.medias[i].name) {
          form.set(options.medias[i].size, options.medias[i]);
        } else {
          form.set(options.medias[i].name, options.medias[i]);
        }
      }
    }
    if (options.etat) {
      form.set('etat', options.etat);
    }
    if (options.order) {
      form.set('order', options.order);
    }
    if (options.statut_edit) {
      form.set('statut_edit', options.statut_edit);
    }

    return this.http.post<any>(
      `${environment.baseApiUrl}point/add`,
      form,
      this.httpFormOptions
    )
    .pipe(
      catchError(errorRes => {
        const errorMessage = errorRes.error.message;
        throw new Error(errorMessage);
      }),
      tap(resData => {
      })
    );
  }

  orderPoints(lang: string, route_id: string, points: any) {

    const form = {
      route_id: route_id,
      user_id: this.userID,
      lang: lang,
      points: points
    };

    return this.http.post<any>(
      `${environment.baseApiUrl}point/order`,
      form,
      this.httpFormOptions
    )
    .pipe(
      catchError(errorRes => {
        const errorMessage = errorRes.error.message;
        throw new Error(errorMessage);
      }),
      tap(resData => {
      })
    );
  }

}
